import script from "./PreviewCardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewCardSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewCardSkeleton.vue?vue&type=style&index=0&id=7511b1b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7511b1b6"]])

export default __exports__